import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { LocalDateTime } from '@js-joda/core';
import { Money } from '../../type/order';
/**
 * Response to real-time order heartbeat request.
 */
export class RealTimeOrderHeartbeatResponse {
    constructor(duration, usageFee, nextHeartbeatTime, latestHlsSegmentEnd) {
        this.duration = duration;
        this.usageFee = usageFee;
        this.nextHeartbeatTime = nextHeartbeatTime;
        this.latestHlsSegmentEnd = latestHlsSegmentEnd;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * The recording time when the next heartbeat is due.
     */
    )
], RealTimeOrderHeartbeatResponse.prototype, "usageFee", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime
    /**
     * The recording time used to perform the heartbeat.
     */
    )
], RealTimeOrderHeartbeatResponse.prototype, "nextHeartbeatTime", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", LocalDateTime)
], RealTimeOrderHeartbeatResponse.prototype, "latestHlsSegmentEnd", void 0);
